import { get } from 'lodash';

export function calcIsVisible(appBannerState, location) {
  if (!get(appBannerState, 'eligibleForUser')) {
    return false;
  } else {
    const blacklistedUrls = get(appBannerState, 'blacklistedUrls', []);
    const whitelistedUrls = get(appBannerState, 'whitelistedUrls', []);
    if (whitelistedUrls.length && !whitelistedUrls.includes(location.pathname)) {
      return false;
    }
    if (blacklistedUrls.includes(location.pathname)) {
      return false;
    }
    return true;
  }
}
